import { motion } from "framer-motion";
import { SectionHeading } from "./SectionHeading";
import { EASE } from "./Motion";

const PILLARS = [
  { verb: "Pitch", copy: "Get your music in front of the right opportunities." },
  { verb: "Release", copy: "Manage your releases and distribution workflow." },
  { verb: "Promote", copy: "Build campaigns around your music." },
  { verb: "Understand", copy: "Turn your data into better career decisions." },
];

export const ValueProp = () => (
  <section id="platform" data-testid="value-prop-section" className="mx-auto max-w-[1400px] px-5 py-section-sm sm:px-8 lg:px-12 lg:py-section">
    <div className="grid gap-10 lg:grid-cols-12">
      <SectionHeading className="lg:col-span-7" eyebrow="The platform / 01" lines={["Your music career.", "One place."]} label="Your music career. One place." />
      <div className="self-end text-base leading-relaxed text-pa-muted md:text-lg lg:col-span-5">
        <p className="text-pa-ink">The modern music industry is fragmented.</p>
        <p className="mt-4">Pitchally brings the tools, opportunities and intelligence artists need into one ecosystem.</p>
      </div>
    </div>
    <div className="mt-16 grid border-l border-t border-white/10 sm:grid-cols-2 lg:mt-24 lg:grid-cols-4">
      {PILLARS.map((p, i) => (
        <motion.article
          key={p.verb}
          data-testid={`value-pillar-${p.verb.toLowerCase()}`}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.9, ease: EASE, delay: i * 0.08 }}
          className="group relative flex min-h-[300px] flex-col justify-between overflow-hidden border-b border-r border-white/10 p-7 lg:min-h-[380px] lg:p-9"
        >
          <span className="absolute inset-x-0 bottom-0 h-0 bg-pa-orange transition-[height] duration-700 ease-out-expo group-hover:h-full" aria-hidden="true" />
          <span className="relative font-mono text-xs text-pa-orange-text transition-colors duration-500 group-hover:text-pa-black">0{i + 1}</span>
          <div className="relative">
            <h3 className="font-display text-6xl uppercase leading-none text-pa-ink transition-colors duration-500 group-hover:text-pa-black sm:text-5xl lg:text-[3.1rem] xl:text-[3.5rem]">{p.verb}</h3>
            <p className="mt-4 max-w-[240px] text-[15px] leading-relaxed text-pa-muted transition-colors duration-500 group-hover:text-pa-black">{p.copy}</p>
          </div>
        </motion.article>
      ))}
    </div>
  </section>
);
